import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import CostEffective from './CostEffective';

export default function Blog() {
  return (
    <>
        <Navbar />
        <CostEffective />
        <Footer />
        <Copyright />
    </>
  )
}